    $(window).on('load', function() {
      // Main slider configuration
      $('.slider-for').slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          fade: false,
          vertical: true,  // Enable vertical mode
          verticalSwiping: true,  // Allow vertical swipe
          asNavFor: '.slider-nav',
          responsive: [
              {
                  breakpoint: 773,  // Breakpoint for tablets
                  settings: {
                      slidesToShow: 1,  // Change to 1 slide at a time on smaller screens
                      slidesToScroll: 1,
                      vertical: false,  // Disable vertical mode for smaller screens
                      verticalSwiping: false  // Disable vertical swipe for smaller screens
                  }
              }
          ]
      });

      // Navigation slider configuration
      $('.slider-nav').slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          vertical: true,
          verticalSwiping: true,
          asNavFor: '.slider-for',
          dots: false,
          focusOnSelect: true,
          responsive: [
              {
                  breakpoint: 773,  // Breakpoint for tablets
                  settings: {
                      slidesToShow: 2,  // Show 3 slides for medium-sized screens (e.g., tablets)
                      vertical: false,  // Disable vertical navigation on smaller screens
                      verticalSwiping: false
                  }
              }
          ]
      });
  });


    $(document).ready(function () {
        var $stickyElement = $(".product__info-wrapper");

        // Add sticky class by default
        $stickyElement.addClass("sticky");

        $(window).on("scroll", function () {
            var footerOffset = $(".custom_footer_section").offset().top;
            var scrollPosition = $(window).scrollTop() + $(window).height();

            if (scrollPosition >= footerOffset) {
                $stickyElement.removeClass("sticky");
            } else {
                $stickyElement.addClass("sticky");
            }
        });
    });



